/**
 * 2.0 brand and offering.
 *
 * Shared by the UI and by outreach email generation. The offering lives here as plain text
 * (rather than being imported from the marketing site, which couples it to React icons) so the
 * email writer can reason about what 2.0 actually sells without inventing services.
 */
export const BRAND = {
  name: '2.0',
  tagline: 'Elevate your vision',
  site: 'https://elevate2point0.com',
  email: 'info@elevate2point0.com',
  /** Product name for this tool, as a 2.0 property. */
  product: 'Atlas',
  productTagline: 'Market research by 2.0',
} as const;

export interface OfferingPillar {
  id: string;
  name: string;
  tagline: string;
  services: readonly string[];
}

/** Mirrors src/lib/services.ts on the marketing site: 17 services across 4 pillars. */
export const OFFERING: readonly OfferingPillar[] = [
  {
    id: 'marketing',
    name: 'Marketing & Brand',
    tagline: 'Make the market notice — and remember — you.',
    services: [
      'Online Promotions',
      'Content Creation',
      'Marketing Materials',
      'Brand Building',
      'SEO',
      'Media Buying & Paid Ads',
      'Event Creation & Planning',
    ],
  },
  {
    id: 'digital',
    name: 'Digital Presence',
    tagline: 'Own every touchpoint, end to end.',
    services: [
      'Website Creation & Management',
      'Managing Digital Platforms',
      'Social Media & Website (full management)',
      'Product Descriptions',
      'Customer Communication',
    ],
  },
  {
    id: 'growth',
    name: 'Growth & Sales',
    tagline: 'Fill the pipeline, then help close it.',
    services: ['International Lead Generation', 'B2B Lead Generation', 'Sales Team Support'],
  },
  {
    id: 'trade',
    name: 'Market & Trade',
    tagline: 'Expand with intelligence on the ground.',
    services: [
      'Market Research',
      'Supplier Sourcing',
      'Trade Show & Exhibition Support',
      'International Local Agent',
    ],
  },
];

export const ALL_SERVICES: readonly string[] = OFFERING.flatMap((pillar) => pillar.services);

/** Compact description of the offering, for prompting. */
export function offeringSummary(): string {
  return OFFERING.map((pillar) => `${pillar.name}: ${pillar.services.join(', ')}`).join('\n');
}
